import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Paper,
  alpha,
} from "@mui/material";
import DialogLoading from "../../App/DialogLoading";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";

export const WarningMessage = ({ body1, body2 }) => {
  return (
    <>
      <Typography
        variant='body1'
        color='text.primary'
        align='justify'
        gutterBottom
      >
        {body1}
      </Typography>
      {body2 && body2 !== "" && (
        <Typography variant='body2' color='text.secondary' sx={{ mt: 2 }}>
          {body2}
        </Typography>
      )}
    </>
  );
};

const WarningDialog = ({
  icon: Icon,
  open,
  onClose,
  title,
  onConfirm,
  loading,
  children,
  confirmText,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='sm'
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: `0 8px 32px ${alpha("#f44336", 0.08)}`,
        },
      }}
    >
      <DialogTitle sx={{ p: 0 }}>
        <Paper
          elevation={0}
          sx={{
            p: 3,
            display: "flex",
            alignItems: "center",
            gap: 2,
            bgcolor: (theme) => alpha(theme.palette.warning.main, 0.03),
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          <Box
            sx={{
              width: 40,
              height: 40,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 2,
              bgcolor: (theme) => alpha(theme.palette.warning.main, 0.08),
            }}
          >
            {Icon ? (
              <Icon color='warning' />
            ) : (
              <PriorityHighIcon color='warning' />
            )}
          </Box>
          <Box flex={1}>
            <Typography variant='h6' fontWeight={600} color='warning.main'>
              {title}
            </Typography>
            <Typography variant='body2' color='text.secondary'>
              Please review carefully before proceeding
            </Typography>
          </Box>
        </Paper>
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        <br />
        {loading ? <DialogLoading /> : children}
      </DialogContent>

      <DialogActions sx={{ p: 3, gap: 2, justifyContent: "flex-end" }}>
        <Button
          onClick={onClose}
          variant='outlined'
          sx={{
            color: "warning.main",
            borderColor: "warning.main",
            "&:hover": {
              borderColor: "warning.main",
              color: "red",
              bgcolor: (theme) => alpha(theme.palette.warning.main, 0.08),
            },
          }}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant='contained'
          sx={{
            backgroundColor: "warning.main",
            "&:hover": {
              backgroundColor: "warning.dark",
            },
          }}
          disabled={loading}
        >
          {confirmText || title}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WarningDialog;
